import request from '@/utils/request'

// 注册
export function saveUserInfo(data) {
  return request({ url: '/tezhao/compet/user/saveUserInfo', method: 'post', data })
}
//保存初赛
export function saveOrUpdateCompetPre(data) {
  return request({ url: '/tezhao/compet/pre/saveOrUpdateCompetPre', method: 'put', data })
}
//获取这个用户在这个竞赛是否有参赛作品
export function getCompetPreByUserId(params) {
  return request({ url: '/tezhao/compet/pre/getCompetPreByUserId', method: 'get', params })
}
//成员列表
export function userList(params) {
  return request({ url: '/tezhao/compet/user/list', method: 'get', params })
}
//新增修改
export function saveOrUpdateTeamUser(data) {
  return request({ url: '/tezhao/compet/user/saveOrUpdateTeamUser', method: 'post', data })
}
//城市
export function cityList(competId, data) {
  return request({
    url: '/tezhao/compet/city/treelist', method: 'get', params: {
      competId,
      ...data
    }
  })
}
//根据手机号查询用户信息
export function getInfo(params) {
  return request({ url: '/tezhao/compet/user/getInfo', method: 'get', params })
}
//修改密码
export function sendSms(data) {
  return request({ url: '/tezhao/sms/sendSms', method: 'post', data })
}
//修改密码
export function updateUserPassword(data) {
  return request({ url: '/tezhao/compet/user/updateUserPassword', method: 'post', data })
}
//删除
export function del(id) {
  return request({
    url: `/tezhao/compet/user/${id}`,
    method: 'delete',
  })
}
//修改密码
export function updatePassword(data) {
  return request({ url: '/tezhao/compet/user/updatePassword', method: 'post', data })
}
//校验手机验证码
export function validateSmsCode(data) {
  return request({ url: '/tezhao/sms/validateSmsCode', method: 'post', data })
}
//退出系统
export function logout(data) {
  return request({ url: '/tezhao/auth/logout', method: 'post', data })
}
//导入
export function userImport(data) {
  return request({ url: '/tezhao/compet/user/import', method: 'post', data })
}
//轮询查询导入用户是否需要下载
export function pollingQuery(params) {
  return request({ url: '/tezhao/compet/user/pollingQuery', method: 'get', params })
}
//下载失败文件
export function exportImportDefeated(identification, competId) {
  return request({ url: `/tezhao/compet/user/exportImportDefeated?identification=${identification}&competId=${competId}&flag=0`, method: 'post', responseType: 'blob', })
}

// 批量导出
export function exportExcel(data) {
  return request({ 
    url: `/tezhao/compet/user/exportExcel`,
    method: 'post', 
    data, 
    responseType: 'blob',
  })
}


// WEBPACK FOOTER //
// ./src/api/signUp.js